import React from "react";

interface PersonAddIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  color?: string;
}

const PersonAddIcon: React.FC<PersonAddIconProps> = ({ width = 32, height = 32, className, color = "currentColor" }) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M21.3334 28V25.3333C21.3334 23.9188 20.7715 22.5623 19.7713 21.5621C18.7711 20.5619 17.4146 20 16.0001 20H8.00008C6.58559 20 5.22904 20.5619 4.22885 21.5621C3.22865 22.5623 2.66675 23.9188 2.66675 25.3333V28"
      stroke={color}
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0001 14.6667C14.9456 14.6667 17.3334 12.2789 17.3334 9.33333C17.3334 6.38781 14.9456 4 12.0001 4C9.05456 4 6.66675 6.38781 6.66675 9.33333C6.66675 12.2789 9.05456 14.6667 12.0001 14.6667Z"
      stroke={color}
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M25.3333 10.6665V18.6665" stroke={color} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M29.3333 14.6665H21.3333" stroke={color} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default PersonAddIcon;
